/* global window */
const CONTAINER = '[data-aut-id=\'seoTextShowMore\']';
const CONTENT = 'div > div';
const PARAGRAPH = 'p';
const FULL_HEIGHT = '100%';

export const setDynamicSeoTextHeightContent = seoTextPanelOpen => {
    const container = document?.querySelector(CONTAINER);
    const content = container?.querySelector(CONTENT);
    const firstParagraph = content?.querySelector(PARAGRAPH);
    const firstParagraphHeight = firstParagraph?.getBoundingClientRect()?.height;
    const { marginTop = 0, marginBottom = 0 } = firstParagraph && window?.getComputedStyle
        ? window.getComputedStyle(firstParagraph)
        : {};

    if (firstParagraphHeight && content) {
        content.style.height = seoTextPanelOpen
            ? FULL_HEIGHT
            : `${firstParagraphHeight + parseInt(marginTop, 10) + parseInt(marginBottom, 10)}px`;
    }
};
